import {uniqueId} from 'lodash';
import {fetchUserToken} from '../../components/SettingsView/UserDetails';

export * from './dataset';
export * from './datasetMetaData';

export const TEMP_DATASERVICE_HEADERS = {
  headers: {
    user: 1,
  },
};

// On the dataservice apis, it requires ticket IDs for updating or maniulating the data.
export const generateTicketId = (prefix: string = 'T') => uniqueId(prefix);

// Need some refactoring here
let token: string | undefined = undefined;

export function getToken() {
  return token; // TODO: Lol, this will obviously not work if invoked prior to the getHeaders, but I'll let frontend engineers sort it out with correct async flow
}

export async function getHeaders(headers?: object) {
  if (!token) {
    token = await fetchUserToken();
  }
  return {
    Authorization: `Bearer ${token}`,
    ...headers,
  };
}
